import React from 'react';
import { GeneralBox } from '../../Shared/GeneralBox';
import ParticlesBG from "../../Shared/ParticlesBG";

// Assets
import wixImage from '../../Assets/Images/Wix_logo.png';
import shopifyImage from '../../Assets/Images/Shopify_logo.png';
import wordpressImage from '../../Assets/Images/Wordpress_logo.png';

export default function Websites() {
  return (
    <div id="websites-page">
      <section className="websites-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">WEBSITES</span>
              </h1>
            </div>
          </div>

          <ParticlesBG />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="services">
        <div className="container">
          <div className="website-intro">
            <p>
              A well-designed website is the digital storefront of today's business world. 
              <span className="highlight"> 75% of users judge a company's credibility based on their website</span>, 
              and businesses with optimized websites generate 67% more leads. 
              The first impression takes only 50 milliseconds—choose a platform that elevates your brand presence.
            </p>
          </div>
          <h2><span className="color-font">Website Platforms</span></h2>
          <div className="box-column-container">
            <div className="box-column">
              <GeneralBox
                title="WIX"
                link="/wix"
                imageSrc={wixImage}
                description="Build your website with Wix's intuitive platform"
                className="homepage-box"
              />
            </div>
            <div className="box-column">
              <GeneralBox
                title="SHOPIFY"
                link="/shopify"
                imageSrc={shopifyImage}
                description="Create an e-commerce website with Shopify"
                className="homepage-box"
              />
            </div>
            <div className="box-column">
              <GeneralBox
                title="WORDPRESS"
                link="/wordpress"
                imageSrc={wordpressImage}
                description="Build a customizable website with WordPress"
                className="homepage-box"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
